/**
 * Capitalizes a string excepe small words like 'of' and 'and' for example.
 * @param  {string} str the string to capitalize
 * @return {string} capitalized string
 */

const lower = (word: string) => {
  return word.toLowerCase();
};

const upper = (word: string) => {
  return word.substr(0, 1).toUpperCase() + word.substr(1);
};

const smartCapitalize = (str: string) => {
  const small = '(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v[.]?|via|vs[.]?)';
  const punct = '([!"#$%&\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)';

  const parts = [];
  const split = /[:.;?!] |(?: |^)["Ò]/g;
  let index = 0;

  while (index < str.length) {
    const m = split.exec(str);
    const endIndex = m ? m.index : str.length;

    const part = str
      .substring(index, endIndex)
      .replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, (all: string) => {
        return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : upper(all);
      })
      .replace(new RegExp(`\\b${small}\\b`, 'ig'), lower)
      .replace(new RegExp(`^${punct}${small}\\b`, 'ig'), (_all, _punct, word) => {
        return _punct + upper(word);
      })
      .replace(new RegExp(`\\b${small}${punct}$`, 'ig'), upper);

    parts.push(part);

    if (m) {
      parts.push(m[0]);
      index = split.lastIndex;
    } else {
      break;
    }
  }

  return parts
    .join('')
    .replace(/ V(s?)\. /gi, ' v$1. ')
    .replace(/(['Õ])S\b/gi, '$1s')
    .replace(/\b(AT&T|Q&A)\b/gi, (all) => {
      return all.toUpperCase();
    });
};

export default smartCapitalize;
